<template>
  <auth-shell>
    <div v-if="accountLogo" class="auth-logo">
      <img :src="accountLogo" :class="{ 'account-logo': !isCustomDomain }"/>
    </div>
    <h4 class="auth-title">Set Your Password</h4>
    <p class="auth-subtitle">
      Choose a new password for your account.
    </p>
    <div :class="['form-group', inputValid(passwordValid)]">
      <label class="auth-label">Your Password</label>
      <input
          type="password"
          class="auth-field"
          placeholder="Password"
          v-model="password"
      />
    </div>
    <div :class="['form-group', inputValid(passwordMatch)]">
      <label class="auth-label">Password Confirmation</label>
      <input
          type="password"
          class="auth-field"
          placeholder="Password Confirmation"
          v-model="password_confirm"
          v-on:keyup.enter="SetPassword()"
      />
    </div>
    <button
        style="margin-top: 8px"
        v-on:click="SetPassword()"
        class="auth-btn-primary"
    >
      <b-spinner
          variant="light"
          v-show="working"
          type="grow"
          small
      ></b-spinner>
      Set Password
    </button>
  </auth-shell>
</template>

<style scoped>
.account-logo {
  width: 50px;
  height: 50px;
}

.has-error .auth-field {
  border-color: #eb4654;
}

.has-error .auth-field:focus {
  border-color: #eb4654;
  box-shadow: 0 0 0 3px rgba(235, 70, 84, 0.12);
}
</style>

<script>
import { getAccountLogo, isCustomDomain } from "../utils/helpers";
import AuthShell from "../components/auth/auth-shell.vue";

export default {
  components: {
    AuthShell,
  },
  data() {
    return {
      password: "",
      password_confirm: "",
      working: false,
      isCustomDomain,
    };
  },
  computed: {
    passwordValid: function () {
      return this.password.length === 0 ? true : this.password.length > 3;
    },
    passwordMatch: function () {
      return this.password == this.password_confirm;
    },
    accountLogo: function () {
      return getAccountLogo();
    }
  },
  methods: {
    inputValid: function (val) {
      return val ? "has-success" : "has-error";
    },
    allFormElementsValid: function () {
      return this.passwordValid && this.passwordMatch;
    },
    async SetPassword() {
      if (this.$route.query.h === undefined) {
        this.$A.AlertUser("password reset token is invalid", "warning");
      } else if (!this.allFormElementsValid() || this.password.length === 0) {
        this.$A.AlertUser("Password is not valid", "warning");
      } else {
        this.$A.AlertUser("Password is updating", "success");
        this.working = true;

        let validationHash = this.$route.query.h;
        let self = this;
        this.working = true;
        await this.$A.UserService.UpdatePasswordViaToken(
            validationHash,
            this.password,
            this.password_confirm
        );
      }
    },
  },
};
</script>
